import { render, staticRenderFns } from "./relatorioCadastro.vue?vue&type=template&id=2cd81354"
import script from "./relatorioCadastro.vue?vue&type=script&lang=js"
export * from "./relatorioCadastro.vue?vue&type=script&lang=js"
import style0 from "./relatorioCadastro.vue?vue&type=style&index=0&id=2cd81354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports